import { IPropertyConverter } from "ta-json";

export class DateConverter implements IPropertyConverter {
    /**
     * Serializes a date object into its ISO string.
     */
    serialize(property: Date): string {
        return property.toISOString();
    }

    /**
     * Deserializes a string value into a date object.
     */
    deserialize(value: string): Date {
        return new Date(value);
    }
}
